import React from 'react';
import { motion } from 'framer-motion';

const courses = [
  { title: "Science Stories", class: "Classes 5-6", subject: "Science", desc: "Short, animated episodes that turn everyday questions into science lessons.", badge: "Cinematic" },
  { title: "Fun with Forces", class: "Classes 6-8", subject: "Physics", desc: "Pushes, pulls, motion, and energy explained with visuals, not formulas first.", badge: "Interactive" },
  { title: "Visual Fractions", class: "Classes 5-8", subject: "Math", desc: "See fractions, patterns, and equations as shapes and movements.", badge: "Visual" },
  { title: "Coding Adventures", class: "Classes 6-8", subject: "Coding", desc: "Start with block-based logic and gently move to text-based coding.", badge: "Hands-on" },
];

const CoursesJunior = () => {
  return (
    <section id="junior" className="py-20 bg-slate-900 border-t border-slate-800">
      <div className="container mx-auto px-6">
        <div className="mb-12">
          <div className="flex items-center gap-4 mb-2">
            <div className="h-1 w-12 bg-cyan-500 rounded-full"></div>
            <span className="text-cyan-400 font-bold uppercase tracking-widest text-sm">Junior Level</span>
          </div>
          <h2 className="text-3xl font-bold text-slate-100 mb-2">Build Strong Foundations: Classes 5–8</h2>
          <p className="text-slate-400 max-w-2xl">Make early science and math feel like stories, not struggles. We avoid heavy jargon and build a rock-solid base.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {courses.map((course, idx) => (
            <motion.div 
              key={idx}
              whileHover={{ y: -5 }}
              className="bg-slate-800 p-6 rounded-xl border border-slate-700 hover:border-cyan-400/50 hover:shadow-lg hover:shadow-cyan-500/10 transition-all cursor-pointer group"
            >
              <div className="flex justify-between items-start mb-4">
                <span className="text-xs font-semibold text-cyan-300 bg-cyan-900/40 px-2 py-1 rounded">{course.subject}</span>
                <span className="text-xs text-slate-500 border border-slate-700 px-2 py-1 rounded">{course.badge}</span>
              </div>
              <h3 className="text-lg font-bold text-slate-100 mb-2 group-hover:text-cyan-300 transition-colors">{course.title}</h3>
              <p className="text-sm text-slate-400 mb-4 line-clamp-3">{course.desc}</p>
              <div className="text-xs text-slate-500 font-medium">{course.class}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoursesJunior;